export const ASK_VECTA_URL = "/AskVecta";

export const isAskVectaPath = (pathname: string): boolean =>
  pathname.replace(/\/+$/, "").toLowerCase() === ASK_VECTA_URL.toLowerCase();

export const navigateTo = (url: string) => window.location.assign(url);

export const openFullPageChat = () => navigateTo(ASK_VECTA_URL);
